export const skinoptions = [
	  { value: 'Blue Tiger', label: 'Blue Tiger', parm: 'skins' },
	  { value: 'Gold', label: 'Gold', parm: 'skins' },
	  { value: 'Radiation', label: 'Radiation', parm: 'skins' },
	  { value: 'Silver', label: 'Silver', parm: 'skins' },
	  { value: 'Tattoos', label: 'Tattoos', parm: 'skins' },
	  { value: 'Tiger', label: 'Tiger', parm: 'skins' },
	  { value: 'Tribe', label: 'Tribe', parm: 'skins' },
];